export default __webpack_public_path__ + "bf3592225be64355b7902cc29401246e.png";